<template>
  <NavBar />
  <BackgroundImage
    :imageUrl="require('@/assets//login/bg.png')"
    :customStyle="{
      height: '100vh',
    }"
  >
    <div class="container">
      <a-flex
        gap="middle"
        justify="center"
        vertical
        :style="{ height: '100vh' }"
      >
        <a-row :gutter="[0, 0]" justify="end">
          <a-col :md="8" :sm="24" :xs="24">
            <a-flex gap="middle" align="end" vertical>
              <a-card
                style="width: 100%"
                :tab-list="tabListNoTitle"
                :active-tab-key="noTitleKey"
                @tabChange="(key) => onTabChange(key, 'noTitleKey')"
              >
                <div v-if="noTitleKey === 'wx'">微信登录</div>
                <div v-else-if="noTitleKey === 'mobile'">
                  <a-form
                    name="custom-validation"
                    :model="formState"
                    v-bind="layout"
                  >
                    <a-form-item has-feedback name="mobile">
                      <a-input
                        class="input-class"
                        v-model:value="formState.mobile"
                        type="text"
                        autocomplete="off"
                        placeholder="请输入手机号"
                      />
                    </a-form-item>
                    <a-form-item has-feedback name="code">
                      <a-row :gutter="[8, 0]">
                        <a-col :md="16" :sm="16" :xs="16">
                          <a-input
                            class="input-class"
                            v-model:value="formState.code"
                            type="text"
                            autocomplete="off"
                            placeholder="请输入验证码"
                          />
                        </a-col>
                        <a-col :md="8" :sm="8" :xs="8">
                          <a-button
                            @click="sendMobileCode"
                            :disabled="isCounting || !mobileValid"
                            class="code-btn"
                            >{{ codeBtnText }}</a-button
                          >
                        </a-col>
                      </a-row>
                    </a-form-item>
                    <p class="help-text">新的手机号验证后，将自动创建账号</p>
                    <a-form-item class="mb-0" :wrapper-col="{ span: 24 }">
                      <a-button
                        type="primary"
                        @click="login"
                        class="submit-btn"
                        html-type="submit"
                        >立即登录</a-button
                      >
                      <a-form-item name="checkAgreement" class="check-item">
                        <a-checkbox
                          class="agreement"
                          v-model:checked="checkAgreement"
                          >我已阅读并同意<a
                            target="_blank"
                            href="https://qihuang.top/user-agreement.html"
                            >用户协议</a
                          >和<a
                            target="_blank"
                            href="https://qihuang.top/privacy-policy.html"
                            >隐私政策</a
                          ></a-checkbox
                        >
                      </a-form-item>
                    </a-form-item>
                  </a-form>
                </div>
              </a-card>
            </a-flex>
          </a-col>
        </a-row>
      </a-flex>
    </div>
  </BackgroundImage>
</template>
<script>
import BackgroundImage from "@/components/BackgroundImage.vue";
import NavBar from "@/components/NavBar.vue";
import api from "@/api";

export default {
  name: "LoginPage",
  components: {
    BackgroundImage,
    NavBar,
  },
  data() {
    return {
      tabListNoTitle: [
        {
          key: "wx",
          tab: "微信登录",
        },
        {
          key: "mobile",
          tab: "手机验证码登录",
        },
      ],
      noTitleKey: "mobile", // 默认激活的 tab
      formState: {
        mobile: "",
        code: "",
      },
      layout: {
        wrapperCol: { span: 24 },
      },
      codeBtnText: "获取验证码",
      countdown: 0,
      isCounting: false,
      checkAgreement: false,
    };
  },
  computed: {
    mobileValid() {
      return /^1[3-9]\d{9}$/.test(this.formState.mobile);
    },
  },
  methods: {
    // 切换登录方式
    onTabChange(value, type) {
      console.log(value, type);
      if (type === "key") {
        this.key = value;
      } else if (type === "noTitleKey") {
        this.noTitleKey = value;
      }
    },

    // 验证手机号码
    validateMobile() {
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(this.formState.mobile);
    },

    // 发送手机验证码
    async sendMobileCode() {
      if (!this.validateMobile()) {
        return this.$message.error("手机号格式错误");
      }
      try {
        const response = await api.utils.sendMobileCode({
          mobile: this.formState.mobile,
        });
        if (response.code === 1) {
          this.startCountdown(60);
          this.$message.success(response.msg);
        } else {
          this.$message.error(response.msg);
        }
      } catch (error) {
        this.$message.error(error.mag || "发送失败");
      }
    },
    // 登录
    async login() {
      // 验证协议
      if (!this.checkAgreement) {
        return this.$message.error("请阅读并同意用户协议和隐私政策");
      }

      // 验证手机号码
      if (!this.validateMobile()) {
        return this.$message.error("手机号格式错误");
      }

      // 验证验证码
      if (!this.formState.code) {
        return this.$message.error("请输入验证码");
      }

      try {
        const response = await api.auth.login(this.formState); // 调用登录方法
        if (response.code === 1) {
          this.$message.success(response.msg);
          // 跳转到首页
          this.$router.push("/");
        } else {
          this.$message.error(response.msg);
        }
      } catch (error) {
        this.$message.error('登录失败');
      }
    },
    // 倒计时
    startCountdown(seconds = 60) {
      this.countdown = seconds;
      this.isCounting = true;
      const timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(timer);
          this.isCounting = false;
          this.codeBtnText = "获取验证码";
          return;
        }
        this.countdown--;
        this.codeBtnText = `${this.countdown}s后重发`;
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
// 卡片
:deep(.ant-card-bordered) {
  padding: 55px 46px 62px 46px;
  border-radius: 8px;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  // box-shadow: 0 1px 4px #1041b51a, 0 4px 12px #5e7bf34d;

  .ant-card-head {
    border-bottom: unset;
    padding: 0;
    display: none;
    &::after {
      border-bottom: 1px solid #999;
    }
    .ant-tabs-tab {
      padding: 12px 0;
    }
    .ant-tabs-tab-btn {
      color: #999;
      font-size: 18px;
      font-weight: 700;
    }
    .ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: #1041b5;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        text-shadow: unset;
      }
    }
  }
  .ant-card-body {
    // padding-top: 64px;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
// 输入框
:deep(.ant-form-item) {
  margin-bottom: 32px;
  .input-class {
    color: #646464;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    padding-top: 13px;
    padding-left: 18px;
    padding-bottom: 13px;
    border-radius: 8px;
    background: #fff;
  }
}
.help-text {
  color: #323232;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  text-align: center;
  margin-bottom: 12px;
}
.submit-btn {
  height: unset;
  width: 100%;
  border-radius: 8px;
  border: none;
  padding: 17px 0;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  background: linear-gradient(
    270deg,
    #8cc2f8 -1.32%,
    #5e7bf3 34.75%,
    #1041b5 100.3%
  );
  box-shadow: 0 1px 4px #1041b51a, 0 4px 12px #5e7bf34d;
}
.code-btn {
  height: 100%;
  width: 100%;
  color: #0d6ffe;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #5e7bf3;
  background-color: white;
}
.check-item {
  padding-top: 32px;
  color: #999;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  padding-bottom: 0;
  margin-bottom: 0;
}
.agreement {
  color: #999;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  a {
    color: #5e7bf3;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
  }
  :deep(.ant-checkbox-inner) {
    border-radius: 50%;
  }
  &:hover {
    :deep(.ant-checkbox-checked:after) {
      border-radius: 50%;
    }
  }
}
</style>
